import React, { useState } from 'react';
import { Lexicon, EditWrapper } from '@nitidbit/lexicon';
import {LEXICON_URL} from '../../constants';
import text from './AboutStrings.json';
import Accordion from '../../shared/Accordion/Accordion';
import Markdown from '../../shared/Markdown';
import Page from '../../shared/Page/Page';
import PageTitle from '../../shared/PageTitle/PageTitle';
import ModalWithOverlay from '../../shared/Modal/ModalWithOverlay';

import women4WomenImg from './women_4_women.png';
import UCSFIconColoredImg from './UCSF_icon_colored.png';
import UWIconColoredImg from './UW_icon_colored.png';
import VAIconColoredImg from './VA_icon_colored.png';
import nitidIconImg from './nitid.png';
import COINIconImg from './COIN_logo.png';
import CWHRIIconImg from './CWHRI_logo.png';
import UOPIconImg from './UOP.png';
import HFHSIconImg from './HFHS.png';
import BFDIconImg from './BFD.png';
import CHERPIconImg from './CHERPlogo.jpg';
import ModalButton from './ModalButton';
import './About.scss';

const About = ({ lexicon }) => {
  const [isModalOn, setisModalOn] = useState(false);
  const [activeProjectDetail, setActiveProjectDetail] = useState(null);

  const buttonNames = [
    lexicon.get('section_title_1'),
    lexicon.get('section_title_2'),
    lexicon.get('section_title_3'),
  ];

  const projectDetails = [
    lexicon.get('pittsburgh_details'),
    lexicon.get('henry_ford_details'),
  ];

  return (
    <>
      <Page pageName="About">
        <div className="content">
          <PageTitle
            text={lexicon.get('about_us')}
            color="dark-blue"
          />
          <Markdown className="page-intro-text" text={lexicon.get('about_text')} />

          <div className="mobile-tablet-only">
            <div className="image-container">
              <img className="partnership-image" src={VAIconColoredImg} alt="VA logo" />
              <img className="partnership-image" src={UWIconColoredImg} alt="UW logo" />
              <img className="partnership-image" src={UCSFIconColoredImg} alt="UCSF logo" />
              <img className="credits-image" src={CWHRIIconImg} alt="CWHRI logo" />
              <img className="credits-image" src={COINIconImg} alt="COIN logo" />
              <img className="credits-image" src={CHERPIconImg} alt="CHERP logo" />
              <img className="credits-image" src={women4WomenImg} alt="Women 4 women veterans logo" />
              <img
                className="partnership-image"
                id="nitid-logo"
                src={nitidIconImg}
                alt="Nitid logo"
              />
            </div>
          </div>

          <Accordion buttonNames={buttonNames}>
            <div className="accordion-section column">
              <div className="sec-1">
                <div>
                  <Markdown className="text-part" text={lexicon.get('section_substance_disorders_markdown_1')} />
                  <ModalButton
                    buttonText={lexicon.get('details_button')}
                    clickHandler={() => {
                      setActiveProjectDetail(0);
                      setisModalOn(true);
                    }}
                  />
                </div>
                <div className="icon-container">
                  <img src={UOPIconImg} id="uop-icon" alt="UOP logo" />
                </div>
              </div>
              <div className="sec-2">
                <div>
                  <Markdown className="text-part" text={lexicon.get('section_reproductive_equity_markdown_1')} />
                  <ModalButton
                    buttonText={lexicon.get('details_button')}
                    clickHandler={() => {
                      setActiveProjectDetail(1);
                      setisModalOn(true);
                    }}
                  />
                </div>
                <div className="icon-container">
                  <img src={HFHSIconImg} alt="HFHS logo" />
                  <img src={BFDIconImg} alt="BFD logo" />
                </div>
              </div>
            </div>
            <div className="accordion-section">
              <Markdown className="text-part list-intro" text={lexicon.get('section_intro_markdown_2')} />
              <Markdown className="text-part" text={lexicon.get('section_list_markdown_2')} />
            </div>
            <div className="accordion-section">
              <Markdown className="text-part list-intro" text={lexicon.get('section_intro_markdown_3')} />
              <Markdown className="text-part" text={lexicon.get('section_list_markdown_3')} />
            </div>
          </Accordion>

          <Markdown className="page-intro-text" text={lexicon.get('nitid')} />
        </div>

        <div className="desktop-only">
          <div className="image-container">
            <img className="partnership-image" src={VAIconColoredImg} alt="VA logo" />
            <img className="partnership-image" src={UWIconColoredImg} alt="UW logo" />
            <img className="partnership-image" src={UCSFIconColoredImg} alt="UCSF logo" />
            <img className="credits-image" src={CWHRIIconImg} alt="CWHRI logo" />
            <img className="credits-image" src={COINIconImg} alt="COIN logo" />
            <img className="credits-image" src={CHERPIconImg} alt="CHERP logo" />
            <img className="credits-image" src={women4WomenImg} alt="Women 4 women veterans logo" />
            <img
              className="partnership-image"
              id="nitid-logo"
              src={nitidIconImg}
              alt="Nitid logo"
            />
          </div>
        </div>
      </Page>

      <ModalWithOverlay
        clickHandler={() => { setisModalOn(false); }}
        isModalOn={isModalOn}
        closeBox="close box"
        extraClass="about-modal"
      >
        <div className="modal-content">
          {
            activeProjectDetail !== null && <Markdown text={projectDetails[activeProjectDetail]} />
          }
        </div>
      </ModalWithOverlay>
    </>
  );
};

const AboutLexicon = new Lexicon(text, 'en', 'src/pages/About/AboutStrings.json');

const EditableAbout = () => (
  <EditWrapper
    component={About}
    lexicon={AboutLexicon}
    apiUpdateUrl={LEXICON_URL}
  />
);

export default EditableAbout;
